import React, { useState } from 'react';
import { Alert } from '@mui/material';

const DISMISS_KEY = 'beta_banner_dismissed';

const BetaBanner = () => {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISS_KEY) === 'true'
  );

  if (process.env.REACT_APP_BETA_DASHBOARD_DISCLAIMER !== 'true') {
    return null;
  }

  if (dismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, 'true');
    setDismissed(true);
  };

  return (
    <Alert
      severity="info"
      onClose={handleDismiss}
      sx={{
        borderRadius: 0,
        py: 0.5,
        fontSize: '0.875rem',
        '& .MuiAlert-message': { py: 0.5 },
      }}
    >
      Beta &middot; Actively improving based on your feedback
    </Alert>
  );
};

export default BetaBanner;
